import api from '../../lib/api';

export type PublicAppStatus = {
  isAvailable: boolean;
  reasonCode: string | null;
  message: string | null;
};

export const fetchCustomerAppStatus = async (): Promise<PublicAppStatus> => {
  const response = await api.get<PublicAppStatus>('/api/customer-app/status', {
    _maxRetries: 1,
  } as any);
  return response.data;
};
